export var REDRAW_BIT = 1;
export var STYLE_CHANGED_BIT = 2;
export var SHAPE_CHANGED_BIT = 4;



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/graphic/constants.js
// module id = /GYF
// module chunks = 3